import styled, { css } from "styled-components";

export const PocoStyled = styled.div`
  display: flex;
  align-items: end;
  width: 110px;
  height: 410px;
  border-radius: 0px 0px 30px 30px;
  border: 2.5px solid var(--cor-contraste);
  position: relative;
  margin-top: 20px;

  border: 2.5px solid
    ${(props) => (props.darkmode ? "#A7A8B5" : "var(--cor-contraste)")};

  background-color: ${(props) => props.darkmode && "var(--poco-fundo)"};

  .conteinerBarra {
    display: flex;
    justify-content: end;
    width: 100%;
    height: 90%;
    flex-direction: column;
    border-radius: 0px 0px 28px 28px;
    overflow: auto;

    .circle {
      width: 111px;
      height: 65px;
      background-color: ${(props) =>
        props.darkmode ? "var(--poco-fundo)" : "white"};
      border: 2.5px solid
        ${(props) => (props.darkmode ? "#A7A8B5" : "var(--cor-contraste)")};
      border-radius: 50%;
      position: absolute;
      top: -30px;
      left: -3px;
    }

    .liquido {
      background: linear-gradient(
        180deg,
        rgba(2, 0, 36, 0) 6%,
        var(--liquido) 4%
      );
      width: 100%;
      height: ${(props) => props.agua}%;
      transition: 1s;
      svg {
        display: ${(props) => props.agua <= 10 && css`none`};
      }
    }
  }

  @media only screen and (min-width: 1920px) {
  }

  /* @media only screen and (max-width: 742px) and (orientation: portrait) {
    width: 90px;
    height: 360px;
    .conteinerBarra {
      .circle {
        width: 91px;
        height: 55px;
      }
    }
  } */

  @media only screen and (max-width: 940px) and (orientation: landscape) {
  }
`;

export const PocoStyled2 = styled.div`
  display: flex;
  align-items: end;
  width: 95px;
  height: 295px;
  border-radius: 0px 0px 30px 30px;
  border: 2.5px solid var(--cor-contraste);
  position: relative;
  background-color: var(--fundo-poco);
  background-color: rgb(220, 220, 220);
  margin-top: 20px;
  .onda {
    color: aqua;
  }
  .conteinerBarra {
    display: flex;
    justify-content: end;
    width: 100%;
    height: 90%;
    flex-direction: column;
    border-radius: 0px 0px 28px 28px;
    overflow: auto;

    .extravasor {
      display: flex;
      flex-direction: column;
      gap: 0px;
      height: 240px;
      width: 100%;
      position: absolute;
      .lineMarcacao {
        display: flex;
        width: 100%;
        gap: 2px;
        position: absolute;
        flex-direction: column;
        bottom: ${(props) => props.nivel}%;
        .linha {
          width: 100%;
          height: 3px;
          border-top: 2px dashed var(--cor-contraste);
        }
        .name {
          font-size: 15px;
          color: var(--cor-contraste);
          font-weight: 600;
          font-size: 14px;
        }
      }
    }
    .nivelminimo {
      display: flex;
      flex-direction: column;
      gap: 0px;
      height: 120px;
      width: 100%;
      position: absolute;
      .lineMarcacao {
        display: flex;
        width: 100%;
        gap: 2px;
        position: absolute;
        flex-direction: column;
        bottom: ${(props) => props.nivelM}%;
        .linha {
          width: 100%;
          height: 3px;
          border-top: 2px dashed var(--cor-contraste);
        }
        .name {
          font-size: 15px;
          color: var(--cor-contraste);
          font-weight: 600;
          font-size: 12px;
        }
      }
    }
    .marcacao {
      position: absolute;
      left: 35px;
      bottom: 150px;
      font-size: 17px;
      color: var(--cor-contraste);
      font-weight: 600;
    }

    .circle {
      width: 96px;
      height: 50px;
      background-color: rgb(220, 220, 220);
      border: 2.5px solid var(--cor-contraste);
      border-radius: 50%;
      position: absolute;
      top: -30px;
      left: -3px;
    }

    .liquido {
      /* background: linear-gradient(
        180deg,
        rgba(2, 0, 36, 0) 6%,
        var(--liquido) 4%
      ); */
      background: linear-gradient(180deg, rgba(2, 0, 36, 0) 6%, #60abff 4%);
      width: 100%;
      height: ${(props) => props.agua}%;
      transition: 1s;
      svg {
        display: ${(props) => props.agua <= 10 && css`none`};
      }
    }
  }

  @media only screen and (max-width: 742px) and (orientation: portrait) {
    width: 95px;
    height: 295px;
    .conteinerBarra {
      .circle {
        width: 96px;
        height: 50px;
      }
    }
  }
`;

export const NivelStyled = styled.div`
  height: 80%;
  position: absolute;
  width: 180px;
  z-index: 5;
`;

export const NiveisStyled = styled.div`
  display: flex;
  position: absolute;
  bottom: ${(props) => props.nivel}%;
  gap: 5px;
  transition: 1s;
  align-items: end;
  .nivel {
    width: 110px;
    height: 3px;
    border-top: 2px dashed
      ${(props) => (props.darkmode ? "#919191" : "var(--cor-contraste)")};
    background-color: transparent;
    position: relative;
    span {
      width: 20px;
      height: 20px;
      position: absolute;
      right: 0;
      top: -12px;
      border-top: 10px solid transparent;
      border-bottom: 10px solid transparent;
      border-right: 10px solid var(--cor-contraste);
      border-right: 10px solid
        ${(props) => (props.darkmode ? "#6B6B6B" : "var(--cor-contraste)")};
    }
  }
  .infoNivel {
    display: flex;
    position: relative;
    height: 25px;
    width: 100px;
    justify-content: end;
    padding-top: 8px;
    font-size: 14px;
    @media (max-width: 600px) {
      font-size: 12px;
    }
    p {
      color: ${(props) =>
        props.darkmode ? "var(--fonte-dark-eee)" : "var(--cor-contraste)"};
    }
    img {
      position: absolute;
      top: 15px;
    }
  }

  @media only screen and (min-width: 1920px) {
  }

  /* @media only screen and (max-width: 800px) and (orientation: portrait) {
    gap: 0px;
    .nivel {
      width: 90px;
    }
    .infoNivel {
      height: 25px;
      width: 75px;
      p {
        font-size: 11px;
      }
    }
  } */

  @media only screen and (max-width: 940px) and (orientation: landscape) {
  }
`;
